import Service from "../../AuthService";
const WorkScheduleEmployee = {
    getWorkScheduleEmployee(page) {
        return Service.get("/work_schedule_employee?page="+page);
    },
    showWorkScheduleEmployee(id){
        return Service.get("/work_schedule_employee/"+id);
    },
    createWorkScheduleEmployee(data){
        return Service.post("/work_schedule_employee",data);
    },
    updateWorkScheduleEmployee(id,data){
        return Service.put("/work_schedule_employee/"+id,data);
    },
    deleteWorkScheduleEmployee(id){
        return Service.delete("/work_schedule_employee/"+id);
    },
    showWorkScheduleByEmployee(id,page){
        return Service.get("/work_schedule_by_employee/"+id+"?page="+page);
    },
    showVocationDay(id){
        return Service.get("/vocation_by_employee/"+id);
    },
    searchEmployeeWorkSchedule(data){
        return Service.post("/work_schedule_employee_search",data)
    },
};
export default WorkScheduleEmployee;
